import React, { useEffect, useState } from 'react'
import StaticPageHeader from '../components/common/StaticPageHeader'
import { callGetWebservice } from '../hooks/api'
import { Helmet } from 'react-helmet-async'
import '../assets/css/allpages.css'

const Faqs = () => {

    const [faqs, setFaqs] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    let requestPacket = {}

    const fetchFaqs = () => {
        callGetWebservice('faqs', requestPacket, (response) => {
            handleWebServiceCallResponse(response);
        });
    }

    useEffect(() => {
        fetchFaqs();
    }, []);

    const handleWebServiceCallResponse = (response) => {
        setFaqs(response.data);
    }

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';

    return (
        <div className="static-page-wrapper">
            <Helmet>
                <title>Frequently Asked Questions (FAQs) | Online Store</title>
                <meta name="description" content="Find answers to frequently asked questions about orders, payments, shipping, tracking, returns, and products." />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/faqs`} />}
            </Helmet>
            <StaticPageHeader title="Frequently Asked Questions" />

            <div className="container static-page-container">
                <div className="static-page-content">
                    
                    <div className="static-faq-container">
                        {faqs.map((faq, index) => (
                            <div className="static-faq-card" key={index}>
                                <div 
                                    className="static-faq-header" 
                                    onClick={() => toggleAccordion(index)}
                                >
                                    <h2 className="static-faq-title">{faq.title}</h2>
                                    <span className="static-faq-indicator">
                                        {activeIndex === index ? '−' : '+'}
                                    </span>
                                </div>

                                <div
                                    className={`collapse ${activeIndex === index ? 'show' : ''}`}
                                >
                                    <div className="static-faq-body">
                                        {faq.description}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default Faqs;